import React, { Fragment, useEffect, useState } from 'react';
import { useParams, useHistory, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';
import { setIdAlert } from 'contexts/actions/authActions';

import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import {
  Widget,
  TableArticles,
  NavRelease,
  WidgetRelease,
  ReleaseText,
  Loader,
  СoincidencesPopap,
  DiagramChart,
  LineChart
} from 'components/common/Elements/Elements';

import DiagramModal from '../Release/parts/DiagramModal/DiagramModal';

import { getRequest } from 'utils/requests';

import {
  pasrsGropsForReleases,
  pasrsReleaseForStatistics,
  pasrsGropsForChips,
  parsChartFromBack
} from './helpers/helpers';

import classes from './Shared.module.scss';

const Shared = ({ mixpanel, onOfNotif }) => {
  const language = useUserState().user.language;
  const username = useUserState().user.username;
  const dispatch = useUserStateDispatch();

  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState(true);

  const [showAllList, setShowAllList] = useState(false);

  const [dataArticles, setDataArticles] = useState([]);
  const [dataChips, setDataChips] = useState([]);
  const [urlForChips, setUrlForChips] = useState('');

  const [coincidences, setCoincidences] = useState(false);

  const [ratioData, setRatioData] = useState();

  const [chartData, setChartData] = useState();

  const [diagramDownload, setDiagramDownload] = useState();
  const [lineChartDownload, setLineChartDownload] = useState();

  let history = useHistory();
  const params = useParams();

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [history.location.pathname]);

  const getData = () => {
    const url = `/api/press-release-groups/${params.groupId}?share_token=${params.token}`;

    getRequest(url)
      .then(res => {
        setIdAlert({
          title: res.pressReleases[0].articleTitle,
          id: res.alertId,
          groupId: res.id
        })(dispatch);
        const forData = pasrsGropsForChips(res);
        if (forData.length === 1) {
          history.replace(
            `/share/${params.token}/${params.groupId}/${forData[0].id}`
          );
        }
        setDataChips(forData);
        setUrlForChips(
          `/api/press-release-groups/${params.groupId}?share_token=${params.token}`
        );
      })
      .catch(err => {
        console.log(err);
      });
    if (!params.releaseId) {
      getRequest(
        `/api/press-release-groups/${params.groupId}?share_token=${params.token}`
      )
        .then(res => {
          setDataArticles(pasrsGropsForReleases(res));
          setDataChips(pasrsGropsForChips(res));
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
        });

      getRequest(
        `/api/press-release-groups/${params.groupId}/chart?share_token=${params.token}`
      )
        .then(res => {
          setChartData(parsChartFromBack(res));
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      setLoadingText(true);
      getRelease();
    }
  };

  const getRelease = () => {
    getRequest(
      `/api/press-releases/${params.releaseId}?show_articles_deleted=true&share_token=${params.token}`
    )
      .then(res => {
        setDataArticles(pasrsReleaseForStatistics(res));
        setLoading(false);
        setLoadingText(false);
      })
      .catch(err => {
        console.log(err);
      });
    getRequest(
      `/api/press-releases/${params.releaseId}/chart?share_token=${params.token}`
    )
      .then(res => {
        setChartData(parsChartFromBack(res));
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleStatistics = idRelease => {
    trackingEvent('look_statisticks', mixpanel, username);
    if (idRelease !== 'allReleaseId') {
      history.push(`/share/${params.token}/${params.groupId}/${idRelease}`);
    } else {
      history.push(`/share/${params.token}/${params.groupId}`);
    }
  };

  const onAddOptionRelease = () => {};

  const onShowList = () => {
    trackingEvent('show_all_articles', mixpanel, username);
    setShowAllList(!showAllList);
  };

  if (loading) {
    return <Loader />;
  }

  const onSelectRatioId = id => {
    trackingEvent('open_ratio', mixpanel, username);
    setRatioData(dataArticles.articles.find(el => el.id === id));
    setCoincidences(true);
  };

  const onDownload = (data, nameChart) => {
    trackingEvent('download_chart', mixpanel, username);
    setDiagramDownload({ data, nameChart });
  };

  const onDownloadLineChart = (data, nameChart) => {
    trackingEvent('download_chart', mixpanel, username);
    setLineChartDownload({ data });
  };

  return (
    <>
      {diagramDownload && (
        <DiagramModal
          setDiagramDownload={setDiagramDownload}
          onOfNotif={onOfNotif}
          const
          options={{
            width: 350,
            scale: 2
          }}
        >
          <div id="capture">
            <DiagramChart
              idBtnDownload={'idExport'}
              data={diagramDownload.data}
              nameChart={diagramDownload.nameChart}
              isAnimation={false}
              onDownload={() => {}}
            />
          </div>
        </DiagramModal>
      )}

      {lineChartDownload && (
        <DiagramModal
          setDiagramDownload={setLineChartDownload}
          onOfNotif={onOfNotif}
          options={{
            width: 730,
            scale: 2
          }}
        >
          <div id="capture">
            <LineChart
              idBtnDownload={'idExport'}
              data={lineChartDownload.data}
              isAnimation={false}
              onDownload={() => {}}
            />
          </div>
        </DiagramModal>
      )}

      <div className={classes.navWrap}>
        <nav className={classes.navRelease}>
          <NavRelease
            dataNav={dataChips}
            onClickChips={handleStatistics}
            mainUrl={urlForChips}
            onClickAdd={onAddOptionRelease}
            modeUser={true}
          />
        </nav>
      </div>
      <section className={classes.release}>
        <div className={classes.boxReleases}>
          <Route
            exact
            path={'/share/:token/:groupId'}
            component={() => {
              return (
                <>
                  {dataArticles.releases &&
                    dataArticles.releases.map(
                      ({ date, idRelease, heading, deleted }, index) => (
                        <Fragment key={idRelease}>
                          {!deleted && (
                            <WidgetRelease
                              date={date}
                              option={index + 1}
                              title={heading}
                              textButton={t(
                                'release',
                                'LOOCK_STATISTICS',
                                language
                              )}
                              className={classes.widgetRelease}
                              onClick={() => handleStatistics(idRelease)}
                              isDeletable={false}
                            />
                          )}
                        </Fragment>
                      )
                    )}
                </>
              );
            }}
          />
          <Route
            exact
            path={'/share/:token/:groupId/:releaseId'}
            component={() => {
              return (
                <div className={classes.textRelease}>
                  {loadingText && <Loader />}
                  {!loadingText && dataArticles.release && (
                    <ReleaseText textInfo={dataArticles.release} />
                  )}
                </div>
              );
            }}
          />
        </div>
        <div className={classes.info}>
          <div className={classes.widgetWrap}>
            <Widget
              title={t('release', 'COUNT_ARTICLES', language)}
              text={dataArticles.ArticlesStatistics.widget.NumberOfOutputs}
              color={'pink'}
              icon={'Icn_Copy'}
            />
            <Widget
              title={t('release', 'TOTAL_AUDIENCE', language)}
              text={dataArticles.ArticlesStatistics.widget.totalAudience}
              color={'purple'}
              icon={'Icn_Audience'}
            />
            <Widget
              title={t('release', 'NUMBER_VIEWS', language)}
              text={dataArticles.ArticlesStatistics.widget.totalNumberOfViews}
              color={'green'}
              icon={'Icn_Views'}
            />
          </div>
          <div className={classes.titleArticles}>
            <h2 className={classes.title}>
              <p>
                {t('release', 'LIST_OF_OUTPUTS', language)}{' '}
                <span>{`(${dataArticles.articles.length})`}</span>
              </p>
            </h2>
          </div>
          <div className={classes.wrapForMobile}>
            {chartData && (
              <LineChart
                data={chartData[0].data}
                onDownload={onDownloadLineChart}
              />
            )}
            <TableArticles
              onRatio={onSelectRatioId}
              dataArticles={dataArticles.articles}
              showAllList={showAllList}
              className={classes.table_mobile}
            />
          </div>
          <div className={cn(classes.paginBtnBox, classes.paginBtnBox_center)}>
            {dataArticles.articles.length > 4 && (
              <button
                className={cn(classes.paginBtn, classes.paginBtn_right)}
                onClick={onShowList}
              >
                {!showAllList
                  ? t('release', 'SHOW_ALL', language)
                  : t('release', 'SHOW_FOUR', language)}
              </button>
            )}
          </div>
          <div className={classes.chartBox}>
            {chartData &&
              chartData.map((dataForChart, index) => {
                return index !== 0 ? (
                  <Fragment key={index}>
                    <DiagramChart
                      data={dataForChart.data}
                      nameChart={t(
                        'diagramChart',
                        dataForChart.titleChart,
                        language
                      )}
                      onDownload={onDownload}
                    />
                  </Fragment>
                ) : (
                  <Fragment key={index}></Fragment>
                );
              })}
          </div>
        </div>
        {coincidences && (
          <СoincidencesPopap
            dataCoincidences={ratioData}
            onClose={() => {
              trackingEvent('close_ratio', mixpanel, username);
              setCoincidences(false);
              mixpanel = { mixpanel };
            }}
            className={classes.coincidences}
            classNameBtnClose={classes.coincidencesBtnClose}
            onOfNotif={onOfNotif}
          />
        )}
      </section>
    </>
  );
};

Shared.propTypes = {
  onOfNotif: PropTypes.func,
  mixpanel: PropTypes.object
};

export default Shared;
